import { HEADER_MOBILE_HEIGHT_CSS_VAR, HEADER_TOP_HEIGHT_CSS_VAR } from "utils/headerHeightCssVars";

const LG_BREAKPOINT = "993px";

export const getStickyScrollOffset = (): number => {
    if (typeof window === "undefined") {
        return 0;
    }

    const styles = getComputedStyle(document.documentElement);
    const headerVar = window.matchMedia(`(min-width: ${LG_BREAKPOINT})`).matches
        ? HEADER_TOP_HEIGHT_CSS_VAR
        : HEADER_MOBILE_HEIGHT_CSS_VAR;
    const headerHeight = parseFloat(styles.getPropertyValue(headerVar)) || 0;
    const anchorNavHeight =
        parseFloat(styles.getPropertyValue("--sizes-anchorNavigationHeight")) || 0;

    return headerHeight + anchorNavHeight;
};
